import {useState, useEffect} from "react";
import LogsView from "./LogsView";

const Recording = ({agentQueues}) => {
  const [recordings, setRecordings] = useState([]);

  // NEW: State to track which recording/log is currently playing
  const [activeId, setActiveId] = useState(null);

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const queues = agentQueues
      ?.map((q) => q?.name?.toLowerCase())
      .filter(Boolean);

    if (!queues?.length) return;

    const fetchAllPagesForQueue = async (queue) => {
      let page = 0;
      let allItems = [];
      let hasMore = true;

      while (hasMore) {
        const res = await fetch(
          `${process.env.REACT_APP_AWS_ENDPOINT}/recordings/client_name/${queue}?page=${page}`,
        );

        if (!res.ok) break;

        const parsed = await res.json();
        allItems = allItems.concat(parsed.recordings || []);
        hasMore = parsed.hasMore;
        page += 1;
      }

      return allItems;
    };

    const fetchRecordings = async () => {
      setIsLoading(true);
      try {
        const results = await Promise.all(queues.map(fetchAllPagesForQueue));

        console.log("Fetched recordings for queues:", JSON.stringify(results));

        const allRecordings = results
          .flat()
          .sort((a, b) => new Date(b.start_time) - new Date(a.start_time));

        setRecordings(allRecordings);
      } catch (error) {
        console.error("Failed to fetch recordings:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchRecordings();
  }, [agentQueues]);

  return (
    <div className="recording-page-wrapper">
      <LogsView
        logs={recordings}
        isLoading={isLoading}
        // Pass these down so individual players can coordinate
        activeId={activeId}
        setActiveId={setActiveId}
      />
    </div>
  );
};

export default Recording;
